import React, {useEffect, useState, useCallback} from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Autocomplete,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Snackbar,
  Tooltip,
  IconButton,
  InputAdornment
} from "@mui/material";
import { useTimezoneSelect, allTimezones } from "react-timezone-select";
import { useSelector, useDispatch } from "react-redux";
import Skeleton from "./skeleton"; 
import { useLocation , useHistory} from "react-router-dom";
import { useTranslation } from "react-i18next";
import  { 
  initialUserDetails, getWorkerFormData , getManagerOptions, 
  getCountriesOptions, getCurrencyOptions, getLocations, 
  validateEmail, initialDisableState, permWorkerDisableFields,
  beelineWorkerDisableFields, isFormChanged
} from "../utils";
import { useRemoteConfig } from "providers";
import { convertStringToArray, convertStringToObject } from "utils/rcUtils";
import { isEmptyObject } from "utils/index";
import  {  OPERATIONAL_DISTRICT_BUILDING, REQUIRED, ADD, EDIT } from '../contants';
import { IS_APPROVER, KILL_CWK_AUTO, IS_NO_EMAIL, EmailDomain, ITContractor } from "config/CONSTANTS";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import _ from 'lodash';
import { updateWorker, addNewWorker, getWorkerDetailsWithRolesSuccess } from "../../../redux/actions/addEditWorker";
import Snack from "components/Snack";
import { MANAGE_WORKERS } from "navigation/CONSTANTS";
import { resetWorkerPin } from "services";
import HelpIcon from '@mui/icons-material/Help';

const UserDetails = () => {
  
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const workerData = location.state && location.state.worker ? location.state.worker : null;
  // console.log("modifiedWorkerData", workerData)
  const isPermWorker = workerData && workerData.workerType === "employee";
  const isBeelineWorker = workerData && workerData.createdBy === "beeline";
  const isMgrWorker = workerData && workerData.isManager && workerData.workerType === "employee";
  const empId = location.state && location.state.empId ? location.state.empId : '';
  const approveForMgr = location.state && location.state.approveForManager
                          ? location.state.approveForManager : {};
  const {workerDocument, loading} = useSelector(state => state.addEditWorker);
  const timeRole = useSelector(state => state.addEditWorker.workerRoles.timeRole || {});
  const { user, isAuthenticated } = useSelector((state) => state.user.auth);
  const { jobFamilies, workdayConfig, managerCostCenterData, 
    managerEmails, countries } = useSelector((state) => state.appConfig);
  const imtRole = useSelector((state) => state.user.imtRole || null);
  const labelStyle = "original";
  const { options: timezoneOptions, parseTimezone } = useTimezoneSelect({
    labelStyle,
    allTimezones,
  });
  const { t, i18n } = useTranslation();
  const jobTypes = useRemoteConfig("jobTypes");
  const jobTypeOptions=jobTypes? convertStringToArray(jobTypes): [];
  const jobDepartments = useRemoteConfig("jobDepartments");
  const jobDepartmentOptions = jobDepartments ? convertStringToArray(jobDepartments) : [];
  const [workerForm, setWorkerForm] = useState({...initialUserDetails});
  const [costCenterOptions, setCostCenterOptions]=useState([]);
  const [productOptions, setProductOptions]=useState([]); 
  const [functionOptions, setFunctionOptions]=useState([]);
  const [jobRoleOptions, setJobRoleOptions]=useState([]);
  const {managerOptions=[], approvingMngrOptions=[]} = managerEmails ?  getManagerOptions(managerEmails, approveForMgr, user, workerData) : {};
  const altCountryOptions = countries ? getCountriesOptions(countries, approveForMgr, user, workerData) : [];
  const currencyOptions = getCurrencyOptions();
  const [districtOptions, setDistrictOptions] = useState([]);
  const [buildingOptions, setBuildingOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [disableFields, setDisableFields] = useState({...initialDisableState})
  const [hideFields, setHideFields] = useState({billRate: true, currency: true});
  const [disableSave, setDisableSave] = useState(true);
  const [readOnly, setReadOnly] = useState(true);
  const [snackControl, setSnackControl] = useState({
    open: false,
    message: "",
    severity: 'success'
  });
  const [isResetPinVisible, setIsResetPinVisible] = useState(true);
  const [isResetPinDisabled, setIsResetPinDisabled] = useState(true);

  useEffect(() => {
    setIsResetPinVisible(workerForm?.workerId ? true : false)
    setIsResetPinDisabled(!workerForm?.pin ? true : false)
  }, [workerForm]);

  const handleResetPin = () => {
    setIsResetPinDisabled(true);
    resetWorkerPin(workerForm.workerId, "").then((response) => {
      setWorkerForm((state) => ({...state, pin: ""}))
      dispatch(getWorkerDetailsWithRolesSuccess({...workerDocument, pin: ""}));
      setSnackControl((state) => ({...state, open: true, message: "Pin Reset successful", severity: "success"}))
    }).catch((err) => {
      setSnackControl((state) => ({...state, open: true, message: "Pin Reset failed", severity: "error"}))
      setIsResetPinDisabled(!workerForm?.pin ? true : false)
    })
  };

  useEffect(() => {
    console.log("IMTime Role", imtRole)
    if(imtRole?.userRole?.role !== "Support"){
          setReadOnly(false);
      }
  },[imtRole])

  useEffect(() => {
    if(workerDocument && Object.keys(workerDocument).length > 0) {
      const formData = getWorkerFormData(workerDocument, user, approveForMgr);
      console.log("workerDocument", formData, initialDisableState);
      setWorkerForm(formData);
      if(!formData?.isNoEmail){
        setDisableFields(state => ({...state, email: false}));
      }
    }

    if(isPermWorker){
      if(isMgrWorker){
        permWorkerDisableFields["isApprover"] = true;
      }
      setDisableFields(state => ({
        ...state,
        ...permWorkerDisableFields
      }))
    }
    if(isBeelineWorker){
      setDisableFields(state => ({
        ...state,
        ...beelineWorkerDisableFields
      }))
    }
  },[workerDocument])

  useEffect(() =>{
      if(workdayConfig && Object.keys(workdayConfig).length > 0){
        
          let {costCenters = [], functions = [], products = []} = workdayConfig;
          if(costCenters && costCenters.length>0){
            costCenters.sort((a,b) => a.costCenter.toLowerCase() > b.costCenter.toLowerCase() ? 1:-1);
            setCostCenterOptions(costCenters);
          }
          if(functions && functions.length>0){
            functions.sort((a,b) => a.function.toLowerCase() > b.function.toLowerCase() ? 1:-1);
            setFunctionOptions(functions);
          }
          if(products && products.length>0){
            products.sort((a,b) => a.product.toLowerCase() > b.product.toLowerCase() ? 1:-1);
            setProductOptions(products)
          }
        
        console.log("workday config", workdayConfig)
      }
  },[workdayConfig])

  useEffect(() => {
      if (jobFamilies && i18n) {
        const language = i18n.language;
        const values = jobFamilies[language]
          ? jobFamilies[language]
          : jobFamilies["en"];
  
      //  console.log("setJobRoleOptions", values)
        setJobRoleOptions(values);
      }
  }, [jobFamilies, i18n]);

  useEffect(() => {
    if(!districtOptions.length >0){
      getLocations(workerData).then(data => {
        const { activityEnabledList=[] } = data;
        setDistrictOptions([...activityEnabledList]);
      });
    }
  }, [])

  useEffect(() => {
      if(districtOptions.length > 0){
          const newValue = workerForm.operationalDistrict;
                if(!newValue || newValue.length<=0){
                  // setValue('sbsBuilding', []);
                  setBuildingOptions([]);
                  setWorkerForm((state) => ({ ...state, 
                  operationalBuilding: []}));
                }
                else{
                  let activatedBuildings =[];
                  districtOptions.forEach(record => {
                      if(newValue.includes(record.district)){
                        console.log("activatedBuildings inside", record.buildings)
                        const buildingsData = record.buildings ? record.buildings : {};
                        let buildingIds = Object.keys(buildingsData).filter(
                          (e) => buildingsData[e].activityEnabled === true
                        );
                        activatedBuildings.push(...buildingIds);
                      }
                    })
                    const currentBuildings = [].concat(workerForm.operationalBuilding || []);;
                    if(currentBuildings.length > 0){
                      const filteredBuldings = currentBuildings.filter(record => activatedBuildings.includes(record) || record == OPERATIONAL_DISTRICT_BUILDING.Building);
                      setWorkerForm((state) => ({ ...state, 
                        operationalBuilding: [...filteredBuldings]}));
                        console.log("activatedBuildings",activatedBuildings, filteredBuldings);
                    }
                
                setBuildingOptions(activatedBuildings);
                  }
        }
  }, [districtOptions, workerForm.operationalDistrict])

  useEffect(() => {
        let manager = {};
        console.log("approveForMgr", approveForMgr);
         if (approveForMgr && !isEmptyObject(approveForMgr)) {
           manager = {
            managerFirstName: approveForMgr?.managerFirstName ?? "",
            managerLastName: approveForMgr?.managerLastName ?? "",
            managerId: approveForMgr?.managerId ?? "",
            managerEmail: approveForMgr?.managerEmail ?? "",
            country: approveForMgr?.managerCountry ?? "",
            countryCode: approveForMgr?.countryCode ?? "",
          };;
         } else if(isEmptyObject(workerData || {})) {
           manager = {
            managerFirstName: user?.firstName ?? "",
            managerLastName: user?.lastName ?? "",
            managerId: user?.workerId ?? "",
            managerEmail: user?.email ?? "",
            country: user?.country ?? "",
            countryCode: user?.countryCode?? "",
          };
         }
         if(!isEmptyObject(manager)){
         setWorkerForm((state) => ({
           ...state,
           ...manager
         }));
        }
  },[user])

  useEffect(() => {
    if(!isPermWorker && workerForm?.managerId && user?.workerId 
      && user?.workerId === workerForm?.managerId){
      setHideFields(state => ({...state, billRate: false, currency: false}));
    }
    validateForm(workerForm);
  //  console.log('isFormChanged', isFormChanged(workerForm, workerDocument), workerForm, workerDocument);
  }, [workerForm, user])

  /**
   * helper function for updating cost center and product for new worker
   * @param {*} managerId 
   */ 
  const updateCostCenter = (managerId) => {
    if (managerId) {
      const managerData = managerCostCenterData[managerId];
      console.log("updateCostCenter", managerData);
      if (managerData) {
        const { costCenter, costCenterId, product, productId } = managerData;
        if (costCenter && costCenterId && product && productId) {
          setWorkerForm((state) => ({
            ...state,
            costCenter: costCenter ?? '',
            costCenterId: costCenterId ?? '',
            product: product ?? '',
            productId: productId ?? ''
          }));
        }
      }
    }
  };
  

  useEffect(() =>{
    // logic to update cost center and product for new worker
    if (user?.isApprover && managerCostCenterData && (!workerData?.costCenter || !workerData?.product)) {
      const managerId = approveForMgr?.managerId || user.workerId;
      updateCostCenter(managerId);
    }
  },[user, managerCostCenterData])  

  const validateForm = (workerForm) => {
    const errors = {};
    
    // List of fields to check validation
    const fieldsToValidate = [
      'firstName', 'lastName', 'email', 'costCenter', 'product', 'function', 
      'jobRole', 'agency', 'country', 'managerId', 'billRate', 'currency'
    ];
  
    fieldsToValidate.forEach(field => {
      if (!workerForm[field] && !(disableFields[field] || hideFields[field])) {
        errors[field] = REQUIRED;
      }
      if(field == 'email' && formErrors?.email && formErrors?.email !== REQUIRED){
        errors[field] = formErrors?.email;
      }
    });
    console.log("fieldsToValidate", workerForm);
    setFormErrors(state => ({...errors}));
    setDisableSave(Object.keys(errors).length > 0);
    return Object.keys(errors).length > 0;
  };
  
  const handleCloseSnack = () => {
    setSnackControl(state => ({...state, open:false, message: ""}));
  }

  const handleChange = (e) => {
    const { id, value, checked } = e.target;
    if(id == "isNoEmail"){
      setDisableFields((state)=> ({...state, email:checked}));
      setWorkerForm((state)=> ({...state, [id]:checked}));
      return;
    }
    if(id == "phone"){
      const numericValue = e.target.value.replace(/[^0-9]/g, '');
      setWorkerForm((state)=> ({...state, [id]:numericValue}));
      return;
    }
    if(id === "costCenter" || id === "product" || id === "function"){
      setWorkerForm((state) => ({ ...state, [id]: value[id], [`${id}Id`]:value['id'] }));
      return ;
    }
    if (id === "jobType"){
      setWorkerForm((state) => ({ ...state, [id]: value }));
      if (value === ITContractor && !workerForm?.operationalDistrict?.length && !workerForm?.operationalBuilding?.length) {
        setWorkerForm((state) => ({
          ...state,
          operationalBuilding: OPERATIONAL_DISTRICT_BUILDING?.Building ?? '',
          operationalDistrict: OPERATIONAL_DISTRICT_BUILDING?.District ?? ''
        }));
      }    
      return ;
    }
    if(id === "manager"){
      const {managerId, managerFirstName, managerEmail, managerLastName} = value || {};
      updateCostCenter(managerId);
      setWorkerForm((state) => ({
        ...state,
        managerId: managerId ?? '',
        managerFirstName: managerFirstName ?? '',
        managerEmail: managerEmail ?? '',
        managerLastName: managerLastName ?? ''
      }));
      return;
    }
    if(id === "alternateCountry"){
      const {countryName, id } = value || {};
      setWorkerForm(state => ({
        ...state,
        alternateCountry: countryName || "",
        alternateCountryCode: id || ""
      }))
      return ;
    }
    if (id === "email") {
      setWorkerForm((state) => ({
        ...state,
        email: value.toLowerCase()
      }));
      return;
    }
    setWorkerForm((state)=> ({...state, [id]:value}));
  }

  // This function will be debounced
  const handleEmailValidation = useCallback(
    _.debounce(async (event) => {
      console.log('debounce called :>> ', event.target.value, empId);
      const {error, message} = await validateEmail(event.target.value, empId);
      console.log('debounce called :>> ', error, message);
        setFormErrors(state => ({...state, 'email': message}));
        setWorkerForm(state => ({...state}))
      // You can perform your email validation logic here
    }, 1000),
    [] // Empty array ensures that this function is only created once
  );

  const handleSave = async (e) => {
    e.preventDefault();
    try{
      const modifiedWorkerData = {...getWorkerFormData(workerForm)};
      const error = validateForm(modifiedWorkerData);
      if(error || !modifiedWorkerData.country){
        return ;
      }
      console.log("modifiedWorkerData", modifiedWorkerData);
      const actionTS = new Date().toISOString();
      modifiedWorkerData.actionTS = actionTS;
      modifiedWorkerData.actionBy = user.workerId;
      if(isEmptyObject(workerData)){ // if adding a new worker
        modifiedWorkerData.actionType = ADD;
       const response = await dispatch(addNewWorker(modifiedWorkerData));
       if(response && response.success){
        console.log("modifiedWorkerData addNewWorker", response);
        const newWorkerData = response.data || {};
        history.replace({
          pathname: location.pathname,
          state: { ...location.state, 
            empId: newWorkerData?.workerId,
            worker: {...newWorkerData}, }, // Add/modify the state
        })
        setSnackControl({
          message: `Temporary worker added successfully. with ID = ${newWorkerData?.workerId}`,
          open: true,
          severity: 'success'
        })
       }
      }else{ // existing worker
        modifiedWorkerData.actionType = EDIT;
        if(modifiedWorkerData.email === "" && !isPermWorker)
        {
            modifiedWorkerData.email = modifiedWorkerData.workerId + EmailDomain;
            modifiedWorkerData.isNoEmail = true;
        }
        console.log("modifiedWorkerData", modifiedWorkerData);
        const response = await dispatch(updateWorker(modifiedWorkerData, timeRole));
        if(response && response.success){
          console.log("modifiedWorkerData updateWorker", response);
          setSnackControl({
            message: `Worker data updated sucessfully`,
            open: true,
            severity: 'success'
          })
        }else{
          setSnackControl({
            message: `Something went wrong. Please try again later`,
            open: true,
            severity: 'error'
          })
        }
      }

    }catch(error){
      console.log('handleSave error', error);
    }
  }

  return (
    <Box>
      <form action="" id="formData">
      <Snack 
        openSnack={snackControl?.open} 
        severity={snackControl?.severity} 
        message={snackControl?.message} 
        handleCloseSnack={handleCloseSnack}>
        </Snack>
        <Card sx={{height: '76vh' ,overflow: "auto", width:"100%", height:'calc(100vh - 160px)'}}>
        {loading ? (
          <>
            <Skeleton />
          </>
        ) : (
          <CardContent style={{ marginLeft: "0%", border: "none", paddingTop: 40}}>
            <Typography variant="h5" color="#616161" marginBottom={3}>
              Edit Worker
            </Typography>
            <hr id="customHr2" />
            <Typography
              sx={{ fontSize: 18, marginTop: 2, flexDirection: "row" }}
              color="text.secondary"
            >
              <h3 style={{ fontWeight: 500 }}>Basic Information </h3>
            </Typography>
            {empId &&
              <>
                <Typography
                  sx={{ fontSize: 18, marginTop: 2, flexDirection: "row" }}
                  color="text.secondary"
                >
                    Worker Id: {empId}
                </Typography>
                <br />{" "}
              </>
            }
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <TextField
                  id="firstName"
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  label="First Name"
                  sx={{ maxWidth: 300, width: "100%" }}
                  size="small"
                  required={true}
                  value={workerForm.firstName}
                  onChange={(e) => handleChange(e)}
                  error={formErrors?.firstName}
                  helperText={formErrors?.firstName}
                  disabled= {disableFields?.firstName || readOnly}
                  inputProps={{readOnly: readOnly}}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <TextField
                  id="lastName"
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  label="Last Name"
                  sx={{ maxWidth: 300, width: "100%" }}
                  size="small"
                  required={true}
                  value={workerForm.lastName}
                  onChange={handleChange}
                  error={formErrors?.lastName}
                  helperText={formErrors?.lastName}
                  disabled= { disableFields?.lastName || readOnly}
                  inputProps={{readOnly: readOnly}}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <TextField
                  id="email"
                  type="text"
                  name="email"
                  placeholder="Email"
                  label="Email"
                  sx={{ maxWidth: 300, width: "100%" }}
                  size="small"
                  required={true}
                  value={workerForm.email}
                  onKeyUp={(e) => {
                    const lowerValue = e.target.value.toLowerCase();
                    handleEmailValidation({
                      ...e,
                      target: {
                        ...e.target,
                        value: lowerValue
                      }
                    })
                  }}
                  onChange={(e) => {
                    setFormErrors(state => ({...state, 'email': 'Validating'}));
                    setDisableSave(true);
                    handleChange(e);
                  }}
                  InputLabelProps={{ shrink: true }}
                  error={formErrors?.email}
                  helperText={formErrors?.email}
                  disabled={disableFields?.email || workerForm.isNoEmail || readOnly}
                  inputProps={{readOnly: readOnly}}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Checkbox
                  value="true"
                  name="isNoEmail"
                  id="isNoEmail"
                  inputProps={{ "aria-label": "controlled", shrink: true, readOnly: readOnly }}
                  checked = {workerForm.isNoEmail}
                  onChange={ readOnly ? undefined : handleChange}
                  disabled={disableFields?.isNoEmail || readOnly}
                />
                No Email
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <TextField
                  id="phone"
                  //type="text"
                  name="phone"
                  sx={{ maxWidth: 300, width: "100%" }}
                  placeholder="phone"
                  label="Phone"
                  size="small"
                  value={workerForm.phone}
                  onChange={handleChange}
                  error={formErrors?.phone}
                  helperText={formErrors?.phone}
                  disabled={disableFields?.phone || readOnly}
                  inputProps={{readOnly: readOnly}}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  options={timezoneOptions}
                  getOptionLabel={(option) =>
                    option.label ? option.label : ""
                  }
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      name="timezone"
                      // value={!formValues.timeZone ? '' : formValues.timeZone}
                      {...params}
                      label="Time Zone"
                      placeholder="Time Zone"
                      // label={t('other.timezone')}
                    />
                  )}
                  id="timezone"
                  size="small"
                  value={workerForm.timezone}
                  onChange={(e, v) =>
                    handleChange({
                      target: {
                        id: "timezone",
                        value: v ? parseTimezone(v.value) : {},
                      },
                    })
                  }
                  disabled= { disableFields?.timezone || readOnly}
                  readOnly={readOnly}
                />
              </Grid>
              <hr id="customHr" />
              <Grid item xs={12}>
                <Typography
                  sx={{ fontSize: 18, marginTop: 2 }}
                  color="text.secondary"
                >
                  <h3
                    style={{
                      marginTop: "-2%",
                      marginBottom: 0,
                      fontWeight: 500,
                    }}
                  >
                    Employment
                  </h3>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      required={true}
                      {...params}
                      label="Cost Center"
                      error={formErrors?.costCenter}
                      helperText={formErrors?.costCenter}
                    />
                  )}
                  id="costCenter"
                  size="small"
                  name="costCenter"
                  options={costCenterOptions}
                  getOptionLabel={(option) => option.costCenter}
                  value={workerForm && workerForm.costCenterId ? {
                    'costCenter': workerForm.costCenter,
                    'id': workerForm.costCenterId
                  } : null}
                  isOptionEqualToValue={(option, value) => 
                    value?.id && option?.id == value?.id
                  }
                  onChange={(e, v) =>
                    handleChange({
                      target: {
                        id: "costCenter",
                        value: v ? v : ""
                      },
                    })
                  }
                  disabled={disableFields?.costCenter || readOnly}
                  readOnly={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField 
                      required={true} 
                      {...params} 
                      label="Product" 
                      error={formErrors?.product}
                      helperText={formErrors?.product}
                    />
                  )}
                  id="product"
                  size="small"
                  name="product"
                  options={productOptions}
                  getOptionLabel={(option) => option.product}
                  value={workerForm && workerForm.productId ? {
                    'product': workerForm.product,
                    'id': workerForm.productId
                  } : null}
                  isOptionEqualToValue={(option, value) => 
                    value?.id && option?.id == value?.id
                  }
                  onChange={(e, v) =>
                    handleChange({
                      target: {
                        id: "product",
                        value: v ? v : ""
                      },
                    })
                  }
                  disabled={disableFields?.product || readOnly}
                  readOnly={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField 
                      required={true} 
                      {...params} 
                      label="Function" 
                      error={formErrors?.['function']}
                      helperText={formErrors?.['function']}
                    />
                  )}
                  id="function"
                  size="small"
                  name="function"
                  options={functionOptions}
                  getOptionLabel={(option) => option.function}
                  value={workerForm && workerForm.functionId ? {
                    'function': workerForm.function,
                    'id': workerForm.functionId
                  } : null}
                  isOptionEqualToValue={(option, value) => 
                    value?.id && option?.id == value?.id
                  }
                  onChange={(e, v) =>
                    handleChange({
                      target: {
                        id: "function",
                        value: v ? v : ""
                      },
                    })
                  }
                  disabled={disableFields?.['function'] || readOnly}
                  readOnly={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField 
                    //  required={true} 
                      {...params} 
                      label="Job Department" 
                    />
                  )}
                  id="jobDepartment"
                  size="small"
                  name="jobDepartment"
                  options={jobDepartmentOptions}
                  value={workerForm.jobDepartment}
                  onChange={(event, value) => handleChange({
                    target:{
                      id:'jobDepartment',
                      value: value || ""
                    }
                  })}
                  disabled={disableFields?.jobDepartment || readOnly}
                  readOnly={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  id="jobRole"
                  name="jobRole"
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField 
                      required={true} 
                      {...params} 
                      label="Job Role" 
                      error={formErrors?.jobRole}
                      helperText={formErrors?.jobRole}
                    />
                  )}
                  size="small"
                  options={jobRoleOptions}
                  getOptionLabel={(option) => option.label || option}
                  value={workerForm.jobRole}
                  isOptionEqualToValue={(option, value) => {
                    return (option == value) || (option?.label == value)
                  }}
                  onChange={(event, value) => {
                    handleChange({
                      target:{
                        id:'jobRole',
                        value: value ? value.value : "",
                      }
                    })
                  }}
                  disabled = {disableFields?.jobRole || readOnly}
                  readOnly={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      id="jobType"
                      name="jobType"
                      {...params}
                      label="Job Type"
                    />
                  )}
                  id="jobType"
                  size="small"
                  options={jobTypeOptions}
                  value={workerForm.jobType}
                  onChange={(event, value) => {
                    handleChange({
                      target:{
                        id:'jobType',
                        value: value ? value : ""
                      }
                    })
                  }}
                  disabled={disableFields?.jobType || readOnly}
                  readOnly={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <TextField
                  required={true}
                  id="agency"
                  type="text"
                  name="agency"
                  placeholder="Agency Name"
                  label="Agency Name"
                  sx={{ maxWidth: 300, width: "100%" }}
                  size="small"
                  value={workerForm.agency}
                  onChange={handleChange}
                  error={formErrors?.agency}
                  helperText={formErrors?.agency}
                  disabled={disableFields?.agency || readOnly}
                  inputProps={{readOnly: readOnly}}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <TextField
                  id="otherId"
                  type="text"
                  name="otherId"
                  placeholder="Other ID"
                  label="Other ID"
                  sx={{ maxWidth: 300, width: "100%" }}
                  size="small"
                  value={workerForm.otherId}
                  onChange={handleChange}
                  error={formErrors?.otherId}
                  helperText={formErrors?.otherId}
                  disabled={disableFields?.otherId || readOnly}
                  inputProps={{readOnly: readOnly}}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      required={true}
                      name="manager"
                      {...params}
                      label="Manager Lookup"
                      error={formErrors?.managerID}
                      helperText={formErrors?.managerID}
                    />
                  )}
                  id="manager"
                  size="small"
                  options={managerOptions}
                  getOptionLabel={(option) =>
                    option && option.managerFirstName
                      ? `${option.managerFirstName} ${option.managerLastName || ""} (${option.managerId || ""})`
                      : "" 
                  }
                  value={managerOptions.filter(option => option?.managerId == workerForm.managerId)[0] || ""}
                  // isOptionEqualToValue = {(option, value) => {
                  //   return (option == value) || (option?.managerId == value)
                  // }}
                  onChange={(event, value) => {
                    handleChange({
                      target: {
                        id: "manager",
                        value: value ? value : {}
                      }
                    })
                  }}
                  disabled={disableFields?.managerId || readOnly}
                  readOnly={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  sx={{ cursor: "pointer", maxWidth: 300, width:'100%' }}
                  label="approvingmanager"
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Approving Manager "
                      id="manager"
                      name="manager"
                    />
                  )}
                  multiple
                  options={approvingMngrOptions}
                  getOptionLabel={(option) =>
                    option && option.managerFirstName
                      ? `${option.managerFirstName} ${option.managerLastName || ""} (${option.managerId || ""})`
                      : ""
                  }
                  value={approvingMngrOptions.filter(option => workerForm?.approvingManager?.includes(option?.managerId))}
                  onChange={(event, value) => handleChange({
                    target:{
                      id: 'approvingManager',
                      value: value && value.length>0 ? value.map(option => option.managerId) : []
                    }
                  })}
                  disabled = {disableFields?.approvingManager || readOnly}
                  readOnly={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                 <TextField
                  id="country"
                  type="text"
                  name="country"
                  sx={{ maxWidth: 300, width: "100%" }}
                  placeholder="country"
                  label="Country"
                  // onChange={handleChange}
                  size="small"
                  value={workerForm.country}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      id="alternateCountry"
                      name="alternateCountry"
                      {...params}
                      label="Operational Country"
                      error={!!formErrors.alternateCountry}
                      helperText={formErrors.alternateCountry}
                    />
                  )}
                  id="alternateCountry"
                  size="small"
                  options={altCountryOptions}
                  getOptionLabel={(option) => option && option.countryName}
                  value={altCountryOptions.filter(option => workerForm?.alternateCountryCode
                    && option?.id == workerForm?.alternateCountryCode)[0] || ""}
                  onChange = {(event, value) => handleChange({
                    target:{
                      id: 'alternateCountry',
                      value : value ? value : {}
                    }
                  })}
                  disabled = {disableFields?.alternateCountry || readOnly}
                  readOnly={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      id="operationalDistrict"
                      name="operationalDistrict"
                      {...params}
                      label="Operational District"
                      error={!!formErrors.operationalDistrict}
                      helperText={formErrors.operationalDistrict}
                    />
                  )}
                  id="operationalDistrict"
                  size="small"
                  options={ districtOptions }
                  getOptionLabel={(option) => option.district?option.district:option}
                  multiple
                  isOptionEqualToValue = {
                    (option, value) => option === value 
                    || option.district === value
                    || option.district === value.district
                  }
                  value={workerForm.operationalDistrict}
                  onChange={(e, newValue) => {
                    console.log("operationalDistrict", newValue)
                    let selectedValues = [];
                    newValue && Array.isArray(newValue) && newValue.length > 0 && newValue.forEach(record => {
                      if(typeof record === "string"){
                        selectedValues.push(record);
                      }else{
                        if(record.district){
                          selectedValues.push(record.district);
                        }
                      }
                    })
                    handleChange({
                     target: {
                            id: "operationalDistrict",
                            value: selectedValues ? selectedValues : []
                          },
                    })  
                  }}
                  readOnly={readOnly}
                  disabled={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Autocomplete
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      id="operationalBuilding"
                      name="operationalBuilding"
                      {...params}
                      label="Operational Building"
                      error={!!formErrors?.operationalBuilding}
                      helperText={formErrors?.operationalBuilding}
                    />
                  )}
                  id="operationalBuilding"
                  size="small"
                  options={buildingOptions}
                  getOptionLabel={(option) => option}
                  multiple
                  value={workerForm.operationalBuilding}
                  onChange={(e, v) =>
                    handleChange({
                      target: {
                        id: "operationalBuilding",
                        value: v ? v : []
                      },
                    })
                  }
                  readOnly={readOnly}
                  disabled={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3}  style={{display:hideFields?.billRate ? 'none' : 'block'}}>
                <TextField
                  id="billRate"
                  type="number"
                  name="billRate"
                  placeholder="Hourly Bill Rate"
                  label="Hourly Bill Rate"
                  error={formErrors?.billRate}
                  helperText={formErrors?.billRate}
                  sx={{ maxWidth: 300, width: "100%" }}
                  // inputProps={{readOnly: readOnly}}
                  size="small"
                  required
                  InputProps={{
                    inputProps:{
                      min: 0,
                    },
                    readOnly: readOnly
                  }}
                  onKeyDown={(evt) =>
                    readOnly ? undefined :
                    ["-", "+", "e", "E"].includes(evt.key) &&
                    evt.preventDefault()
                  }
                  value={workerForm.billRate}
                  onChange={handleChange}
                  disabled={readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3}  style={{display:hideFields?.billRate ? 'none' : 'block'}}>
                <Autocomplete
                  sx={{ maxWidth: 300, width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      required={true} 
                      {...params} 
                      label="Currency" 
                      error={formErrors?.currency}
                      helperText={formErrors?.currency}
                    />
                  )}
                  id="currency"
                  size="small"
                  name="currency"
                  options={currencyOptions}
                  getOptionLabel={(option) => option?.currency_code || option}
                  value={workerForm.currency}
                  isOptionEqualToValue={(option, value) => option == value || option?.currency_code == value}
                  onChange={(event, value) => {
                    handleChange({
                      target:{
                        id: 'currency',
                        value: value ? value.currency_code : ""
                      }
                    })
                  }}
                  readOnly={readOnly}
                  disabled={readOnly}
                />
              </Grid>
              <hr id="customHr"></hr>
              <Grid item xs={12}>
                <Typography
                  sx={{ fontSize: 18, marginTop: 2}}
                  color="text.secondary"
                >
                  <h3
                    style={{
                      marginTop: "-2%",
                      marginBottom: 0,
                      fontWeight: 500,
                    }}
                  >
                    Administrative
                  </h3>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} display={"flex"} alignItems={'center'}>
                <Grid item xs={11}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        clearable
                        disabled={disableFields?.expirationDate || readOnly}
                        readOnly={readOnly}
                        defaultValue={null}
                        value={
                          workerForm.expirationDate != '' 
                          && workerForm.expirationDate != 'NaN-NaN-NaN' ? 
                          dayjs(workerForm.expirationDate) : null
                        }
                        name="expirationDate"
                        id="expirationDate"
                        disablePast
                        label="Expiration Date"
                        onChange={(newValue) => {
                        handleChange({
                          target:{
                            id:'expirationDate',
                            value : newValue.$d.toISOString()
                          }
                        })
                        }}
                        renderInput={(params) => ( <TextField 
                          value={
                            workerForm.expirationDate != '' 
                            && workerForm.expirationDate != 'NaN-NaN-NaN' ? 
                            dayjs(workerForm.expirationDate) : null
                          }
                          {...params} 
                          /> )}
                        // onChange={((newValue) => validate(newValue), (newValue) => setDateValue(newValue))}
                        slotProps={{
                          field: { clearable: true },
                          actionBar: { actions: ['clear'] },
                          textField: {
                            size: 'small',
                          //  required: true,
                            id: 'datef',
                            clearable: true,
                            error: false,
                            readOnly: true
                          }
                        }}
                        sx={{ maxWidth: 300, width: "100%" }}
                      />

                      <p
                        style={{ color: '#d32f2f', display: formErrors?.expirationDate, fontFamily: 'Roboto', fontSize: '0.75rem' }}
                        className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained Mui-required css-k4qjio-MuiFormHelperText-root">
                        {formErrors?.expirationDate}
                      </p>
                    </LocalizationProvider>
                </Grid>
                  <InputLabel id="expirationDate-label">
                    <Tooltip 
                      title={ <Typography fontSize={14}>On this date, the user will be deactivated, and access to applications will be revoked.</Typography> } 
                      arrow
                      >
                      <IconButton size="small" style={{ padding: 0, marginLeft: 4 }}>
                        <HelpIcon fontSize="medium" />
                      </IconButton>
                    </Tooltip>
                   </InputLabel>
                </Grid>
              <Grid item xs={2} style={{ marginLeft: "-2px" }}>
                <Checkbox
                  id="isActiveWorker"
                  name="isActiveWorker"
                  inputProps={{ "aria-label": "controlled", readOnly: readOnly }}
                  checked={workerForm.isActiveWorker}
                  onChange={(e) => readOnly ? undefined : handleChange({
                    target:{
                      id: 'isActiveWorker',
                      value: e.target.checked
                    }
                  })}
                  disabled= {disableFields?.isActiveWorker || readOnly}
                />
                Active
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} >
                <Checkbox
                  name="isApprover"
                  id="isApprover"
                  inputProps={{ "aria-label": "controlled", readOnly: readOnly}}
                  checked={workerForm.isApprover}
                  onChange={(e) => readOnly ? undefined : handleChange({
                    target:{
                      id: 'isApprover',
                      value: e.target.checked
                    }
                  })}
                  disabled= {disableFields?.isApprover || readOnly}
                />
                Approver
              </Grid>
              <Grid item xs={2} >
                {isResetPinVisible ? (
                  <Button
                    color="primary"
                    variant="text"
                    disabled={isResetPinDisabled}
                    // className={classes.button}
                    onClick={handleResetPin}
                  >
                    {t("other.tlResetPin")}
                  </Button>
                ) : null}
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ marginTop: "2%", textAlign: "right", marginLeft: 4 }}
            >
              <div>
                <Button
                  size="medium"
                  variant="outlined"
                  onClick={() => history.push(MANAGE_WORKERS, { isManageWorkers: true })}
                  style={{ marginRight: 10, display: readOnly ? "none" : "" }}
                >
                  Cancel
                </Button>
                <Button 
                  style={{marginRight: 30, display: readOnly ? "none" : ""}}
                  size="medium" 
                  variant="contained" 
                  id="svBtn"
                  disabled = {disableSave || readOnly}
                  onClick={handleSave}
                >
                  Save
                </Button>
              </div>
            </Grid>
          </CardContent>
        )}
        </Card>
      </form>
    </Box>
  );
};

export default UserDetails;
